var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.sampleserver==1)?_c('div',{staticClass:"sample"},[_c('span',{staticClass:"txt"},[_vm._v("샘플서버 입니다. 입금 NO!!! 출금 NO!!! 솔루션문의:@yewtoto")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }